import { Component, Output } from '@angular/core';
import { FormArray, FormGroup, UntypedFormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';
import {
  AccountSetupDialogStore,
  TaxRateMapping
} from '../account-setup-dialog.store';
import { takeUntil } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';
import { MatOption } from '@angular/material/core';
import { MatSelect } from '@angular/material/select';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { FlexModule } from '@angular/flex-layout';
import { NgIf, NgFor, AsyncPipe, TitleCasePipe } from '@angular/common';

@Component({
    selector: 'generic-tax-mappings',
    templateUrl: './generic-tax-mappings.component.html',
    standalone: true,
    imports: [NgIf, FlexModule, NgFor, ReactiveFormsModule, MatFormField, MatLabel, MatSelect, MatOption, AsyncPipe, TitleCasePipe]
})
export class GenericTaxMappingsComponent {
  form: FormArray<FormGroup<any>>;

  loading$ = this.store.loadingTaxRates$;

  @Output() newFormGroup = new BehaviorSubject<FormArray>(
    new FormArray<any>([])
  );
  optionsByTaxType$ = this.store.optionsByTaxType$;
  integration$ = this.store.integration$;
  taxRateMappings$ = this.store.taxRateMappings$;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private store: AccountSetupDialogStore
  ) {
    this.store.getTaxRates();
    this.store.taxRateMappings$
      .pipe(takeUntil(this.store.destroy$))
      .subscribe((taxRates) => this.setupFormControls(taxRates));
  }

  private setupFormControls(taxRates: TaxRateMapping[]) {
    this.form = this.formBuilder.array(
      taxRates.map((taxRate) => this.taxRateToFormGroup(taxRate))
    );
    this.newFormGroup.next(this.form);
  }

  private taxRateToFormGroup(taxRate: TaxRateMapping) {
    return this.formBuilder.group({
      name: this.formBuilder.control(taxRate.name),
      value: this.formBuilder.control(taxRate.value),
      sequence: this.formBuilder.control(taxRate.sequence),
      type: this.formBuilder.control(taxRate.type),
      reference: this.formBuilder.control(
        taxRate.reference,
        Validators.required
      )
    });
  }
}
